import { Typography, styled } from '@mui/material';

export const UnderLineTextStyled = styled(Typography)(({ theme }) => ({
  cursor: 'pointer',
  color: theme.palette.primary.main,
  textDecoration: 'underline',
}));
export const UserBlockStyled = styled('div')(() => ({
  height: 516,
}));
